import _toConsumableArray from "/home/ruben/dev/priv/whatsalyzer.com/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Chart, registerables } from '../dist/chart.mjs';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;